import {Menu} from '@baidu/luffy-comp-menu';
export {MenuItem, MenuPopper, Submenu} from '@baidu/luffy-comp-menu';
export type {MenuItemId, MenuProps} from '@baidu/luffy-comp-menu';
export default Menu;
